import PageLayout from "@/components/layout/PageLayout";
import PageBreadcrumb from "@/components/layout/PageBreadcrumb";

const PrivacyPolicyPage = () => {
  return (
    <PageLayout>
      <PageBreadcrumb currentPage="Privacy Policy" />
      <section className="py-6 sm:py-8 px-4 bg-gradient-to-b from-white to-purple-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8 animate-fade-up">
            <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-primary-dark">Privacy Policy</h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-neutral mb-6">Last updated: {new Date().toLocaleDateString()}</p>
              
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">1. Information We Collect</h2>
                  <p className="text-neutral mb-4">
                    We collect information that you provide directly to us, including when you fill out forms, request quotes, or communicate with us. This may include:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Personal identification information (name, email address, phone number)</li>
                    <li>Insurance policy details and preferences</li>
                    <li>Payment and billing information</li>
                    <li>Claims history and related documentation</li>
                    <li>Property information for home insurance</li>
                    <li>Vehicle information for auto insurance</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">2. How We Use Your Information</h2>
                  <p className="text-neutral mb-4">
                    We use the information we collect to provide, maintain, and improve our services. Specifically, we use your information to:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Process your insurance applications and quotes</li>
                    <li>Communicate with you about your policies and claims</li>
                    <li>Send important updates about our services</li>
                    <li>Analyze and improve our service offerings</li>
                    <li>Comply with legal obligations and requirements</li>
                    <li>Prevent fraud and enhance security</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">3. Information Sharing</h2>
                  <p className="text-neutral mb-4">
                    We take your privacy seriously and do not sell your personal information. We may share your information with:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Insurance carriers to process your applications</li>
                    <li>Service providers who assist in our operations</li>
                    <li>Legal authorities when required by law</li>
                    <li>Business partners with your consent</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">4. Your Rights and Choices</h2>
                  <p className="text-neutral mb-4">
                    You have certain rights regarding your personal information:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Access your personal information</li>
                    <li>Request corrections to your data</li>
                    <li>Opt-out of marketing communications</li>
                    <li>Request deletion of your information</li>
                    <li>Object to certain data processing</li>
                    <li>Data portability rights</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">5. Security Measures</h2>
                  <p className="text-neutral mb-4">
                    We implement appropriate technical and organizational security measures to protect your personal information, including:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Encryption of sensitive data</li>
                    <li>Regular security assessments</li>
                    <li>Employee training on data protection</li>
                    <li>Secure data storage systems</li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PrivacyPolicyPage;